import { render, staticRenderFns } from "./PlayerSelect.vue?vue&type=template&id=2453c4b8&scoped=true"
import script from "./PlayerSelect.vue?vue&type=script&lang=ts"
export * from "./PlayerSelect.vue?vue&type=script&lang=ts"
import style0 from "./PlayerSelect.vue?vue&type=style&index=0&id=2453c4b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453c4b8",
  null
  
)

export default component.exports